// extracted by mini-css-extract-plugin
export default {"DialogFooterButtons":"CheckTagNameDialog-module__DialogFooterButtons__Bc0S9t8"};